function normalizeBaseUrl(value: string | undefined): string {
    return String(value ?? '/').replace(/\/+$/, '');
}

export function normalizeCrmName(value: string | null | undefined): string {
    return String(value ?? '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');
}

export function getCrmLogoCandidates(crm: string | null | undefined): string[] {
    const name = normalizeCrmName(crm);
    const baseUrl = normalizeBaseUrl(import.meta.env.BASE_URL);
    const prefix = `${baseUrl}/img/platforms`;

    const other = [
        `${prefix}/other.svg`,
        `${prefix}/other.png`,
    ];

    if (!name) return other;

    return [
        `${prefix}/${name}.svg`,
        `${prefix}/${name}.png`,
        ...other,
    ];
}
